export { default } from './Marquee';
